// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3nAbf","detailsBorder":"styles_detailsBorder__31bXF"};